import React, { useState, memo } from 'react';
import { func, bool, number } from 'prop-types';
import { MAX_SCREEN_SHARES } from '@shoflo/polymer';
import {
  faTv,
  faPhotoVideo,
  faChevronDown,
  faImage,
  faFileVideo
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  StyledDropdown,
  StyledDropdownToggle,
  DropdownMenuItem,
  DropdownMenuItemIcon,
  StyledFontAwesomeIcon,
  StyledDropdownMenu
} from './ManageDropdown.styled';

function ManageDropdown({
  onShareLocalScreen,
  onUploadMedia,
  onAddStockMedia,
  onChooseBackground,
  directorScreenShareExists,
  screenShareCount
}) {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  function toggle() {
    setDropdownOpen(prevState => !prevState);
  }

  const isScreenShareDisabled =
    directorScreenShareExists || screenShareCount >= MAX_SCREEN_SHARES;

  const targetElementId = 'add-source-dropdown';

  return (
    <StyledDropdown toggle={toggle} id={targetElementId} isOpen={dropdownOpen}>
      <StyledDropdownToggle data-testid={targetElementId}>
        Manage{' '}
        <StyledFontAwesomeIcon
          data-testid="fontIcon"
          icon={faChevronDown}
          size="xs"
        />
      </StyledDropdownToggle>
      <StyledDropdownMenu>
        <DropdownMenuItem
          onClick={onShareLocalScreen}
          data-testid="share-your-screen"
          disabled={isScreenShareDisabled}
        >
          <DropdownMenuItemIcon>
            <FontAwesomeIcon icon={faTv} color="#00000" />
          </DropdownMenuItemIcon>
          Share your screen
        </DropdownMenuItem>

        <DropdownMenuItem onClick={onUploadMedia} data-testid="upload-media">
          <DropdownMenuItemIcon>
            <FontAwesomeIcon icon={faFileVideo} color="#00000" />
          </DropdownMenuItemIcon>
          Upload content
        </DropdownMenuItem>

        <DropdownMenuItem
          onClick={onAddStockMedia}
          data-testid="add-stock-media"
        >
          <DropdownMenuItemIcon>
            <FontAwesomeIcon icon={faPhotoVideo} color="#00000" />
          </DropdownMenuItemIcon>
          Add stock content
        </DropdownMenuItem>

        <DropdownMenuItem
          onClick={onChooseBackground}
          data-testid="choose-background"
        >
          <DropdownMenuItemIcon>
            <FontAwesomeIcon icon={faImage} color="#00000" />
          </DropdownMenuItemIcon>
          Choose background
        </DropdownMenuItem>
      </StyledDropdownMenu>
    </StyledDropdown>
  );
}

ManageDropdown.propTypes = {
  onShareLocalScreen: func.isRequired,
  onUploadMedia: func.isRequired,
  onAddStockMedia: func.isRequired,
  onChooseBackground: func.isRequired,
  directorScreenShareExists: bool,
  screenShareCount: number
};

export default memo(ManageDropdown);
